import React from 'react'
import PropTypes from 'react-proptypes'

const Slices = ({
  slices,
  arc,
  colour,
  category,
  onMouseEnter,
  onMouseOut,
  highlightedSlice,
}) => {
  return (
    <g className="slices">
      {slices.map((d, i) => {
        return (
          <path
            key={i}
            fill={colour(d.data.currency)}
            d={arc(d)}
            onMouseEnter={() => onMouseEnter(d)}
            onMouseOut={() => onMouseOut(d)}
          />
        )
      })}
    </g>
  )
}
Slices.propTypes = {
  slices: PropTypes.array.isRequired,
  arc: PropTypes.func.isRequired,
  colour: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  highlightedSlice: PropTypes.object,
}
export default Slices



// WEBPACK FOOTER //
// ./src/components/Donut/Slices.js